export const meta = {
    title: "Check Your Domain's DMARC Record – AI-Based Protection",
    ogTitle: "One Click DMARC Record Checker - AI-Based Protection",
    description: "Instantly check your DMARC record and protect your domain from email spoofing and phishing with DMARCFlow. No DNS expertise needed."
};